<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid 
            [style]="(`height: calc(100vh - ${offset}px)`)" 
            id="shuntMovesGrid" class="grid theme-dependent"
            noDataText="" 
            [dataSource]="dataSource" 
            [allowColumnResizing]="true" 
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false" 
            [showBorders]="true" 
            [remoteOperations]="false" 
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'shunt-moves-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)" 
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns" 
            keyExpr="id" 
            width="100%">
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [visible]="true" [displayMode]="'full'" [showPageSizeSelector]="true" [showInfo]="true"
                [showNavigationButtons]="true">
            </dxo-pager>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>
            <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Shunt Management</div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('number')" caption="ID" [minWidth]="100" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('carrier')" caption="Carrier" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('trailerNumber')" caption="Trailer #" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('currentShuntLocation')" caption="Current Location" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('newShuntLocation')" caption="New Location" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('shuntPriority')" caption="Priority" [minWidth]="25" cellTemplate="shuntPriority" sortOrder="asc" [calculateSortValue]="shuntPrioritySortValue"
                [lookup]="{ dataSource: shuntPriorityOptions, valueExpr: 'value', displayExpr: 'text' }" [headerFilter]="{ dataSource: shuntPriorityOptions }">
            </dxi-column>            
            <dxi-column [dataField]="gridFieldName('notes')" caption="Note" [minWidth]="50" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" caption="Date Created" [minWidth]="150" dataType="date" cellTemplate="created" [visible]="false"></dxi-column>
            <dxi-column dataField="employee.name" caption="Created By" cellTemplate="createdBy" 
                [visible]="false" [minWidth]="250" [calculateFilterExpression]="nameOrEmailFilter" [visible]="false"></dxi-column>
            <dxi-column caption="Actions" cellTemplate="button" alignment="center" [minWidth]="100" [visible]="isCompleteShuntButtonVisible" [showInColumnChooser]="isCompleteShuntButtonVisible"></dxi-column>
            <dxi-column type="buttons" caption="View">
                <dxi-button text="view" icon="eyeopen" hint="view" [onClick]="onView"></dxi-button>
            </dxi-column>
            
            <div *dxTemplate="let cellInfo of 'shuntPriority'">
                @if (getCellData(cellInfo).shuntPriority !== null) {
                    <span class="badge" [ngClass]="getShuntPriorityBadgeClass(getCellData(cellInfo).shuntPriority)">
                        {{ cellInfo.value | shuntPriority}}
                    </span>
                }
            </div>
            <div *dxTemplate="let cellInfo of 'created'">
                {{ getCellData(cellInfo).created | date: dateTimeFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'createdBy'">
                <user-avatar-email
                    [email]="getCellData(cellInfo).employee.email"
                    [name]="getCellData(cellInfo).employee.name"
                    [avatarUrl]="getCellData(cellInfo).employee.avatarUrl"
                    [employeeId]="getCellData(cellInfo).employee.id"
                ></user-avatar-email>
            </div>
            <div *dxTemplate="let cellInfo of 'button'">
                <dx-button
                    stylingMode="contained"
                    text="Complete Shunt"
                    type="success"
                    (onClick)="completeShunt(getCellData(cellInfo).number, getCellData(cellInfo).yardEntityType)">
                </dx-button>
            </div>
        </dx-data-grid>
    </div>

    <filter-panel [(isOpened)]="isFilterPanelOpened" (onSearch)="applyFilters()" (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()">
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="filterModelName('number')" editorType="dxTextBox" [editorOptions]="{placeholder: 'ID', stylingMode: 'filled'}"></dxi-item>
            <dxi-item [dataField]="filterModelName('carrier')" editorType="dxTextBox" [editorOptions]="{placeholder: 'Carrier', stylingMode: 'filled'}"></dxi-item>
            <dxi-item [dataField]="filterModelName('trailerNumber')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Trailer #', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('currentShuntLocation')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Current Shunt Location', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('newShuntLocation')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'New Shunt Location', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('shuntPriority')" editorType="dxSelectBox" [editorOptions]="{
                    placeholder: 'Priority',
                    stylingMode: 'filled',
                    items: shuntPriorityOptions,
                    valueExpr: 'value',
                    displayExpr: 'text',
                    showClearButton: true
                }">
            </dxi-item>            
            <dxi-item [dataField]="'notes'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Note', stylingMode: 'filled' }" [label]="{ text: 'Note' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('created')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Date Created', stylingMode: 'filled', displayFormat: 'shortDate' }"></dxi-item>
            <dxi-item
                [dataField]="'employee.name'"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Created By', stylingMode: 'filled' }"
                [label]="{ text: 'Created By' }"
            ></dxi-item>
        </dx-form>
    </filter-panel>
    
    <shunt-move-form [(visible)]="isShuntMovePopupOpened" [formData]="formData" [isReadOnly]="true"></shunt-move-form>
    <app-notes
        [entityId]="pendingNumber"
        [noteType]="pendingNoteType"
        [canCreate]="true"
        mode="invisible"
        (noteSaved)="onNoteSaved()"
        (noteCanceled)="onNoteCanceled()"
    ></app-notes>
</div>